import {createSelector} from '@store/@common';

import AuthStore from 'stores/AuthStore';

const baseState = createSelector(AuthStore);

export const authUser = createSelector([baseState], s => s.user);

export const isAuthUserAdmin = createSelector([authUser], user => user.isAdmin());

export const userFlags = createSelector([authUser], u => u?.flags);

export const userHasFlag = createSelector([userFlags], uFlags => flag => uFlags?.includes(flag));

export const getAuthUserPermission = createSelector([authUser], user => (permission: string) => {
  return user.permissions.includes(permission);
});

export const isAdminOrHasPermission = createSelector(
  [isAuthUserAdmin, getAuthUserPermission],
  (isAdmin, hasPermission) => (permission: string) => {
    return isAdmin || hasPermission(permission);
  }
);

export const userHasAnyFlag = createSelector(
  [userHasFlag],
  hasFlag => flags => flags.some(hasFlag)
);
